export const SESSION_ID_HEADER_NAME = 'x-session-id';
export const PRODUCT_ID_HEADER_NAME = 'x-product-id';

export const API_BASE_URL = '/api/generic-onboarding/v1/';

export enum ApiPath {
  PRODUCT_CONFIGURATION = '/product-configuration',
  PRODUCT_META_DATA = '/product-configuration/metaData',
  PRODUCT_WORTH = '/product-configuration/calculate-worth',
}
